<template>
  <div id="footer">
    <div class="f_top">
      <div class="size">
        <div class="l_box">
          <ul>
            <li>
              <router-link :to="{ name: 'notice' }">공지사항</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'agreement' }">이용약관</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'privacy' }"
                >개인정보취급방침</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'responsibility' }"
                >책임의 한계 및 법적고지</router-link
              >
            </li>
            <li><a href="javascript:;">제휴문의</a></li>
          </ul>
        </div>
        <div class="r_box">
          <ul>
            <li>
              <a href="javascript:;"
                ><img src="@/assets/images/f_ico01.png"
              /></a>
            </li>
            <li>
              <a href="javascript:;"
                ><img src="@/assets/images/f_ico02.png"
              /></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="f_btm">
      <div class="size clear" v-if="shopInfo">
        <div class="boxes box1">
          <div class="f_logo img"><img src="@/assets/images/h_logo.png" /></div>
          <div class="btm">
            <b>{{ shopInfo.companyName }}</b>
            <ul>
              <li>대표자 : {{ shopInfo.ownerName }}</li>
              <li>{{ shopInfo.address }}</li>
            </ul>
            <ul class="last">
              <li>사업자등록번호 : {{ shopInfo.businessNumber }}</li>
              <li>통신판매업신고 : {{ shopInfo.onlineBusinessNumber }}</li>
            </ul>
          </div>
        </div>
        <div class="boxes box2">
          <div class="tp">
            <b>고객센터</b>
            <p>통화량이 많을 땐 게시판을 이용해주세요.</p>
          </div>
          <div class="btm">
            <a>{{ shopInfo.phone }}</a>
            <div class="b_wrap">
              <b>{{ shopInfo.workTime }}</b>
              <b>{{ shopInfo.lunchTime }}</b>
            </div>
          </div>
        </div>
        <div class="boxes box3">
          <ul class="clear">
            <li>
              <a href="javascript:;">
                <p class="img"><img src="@/assets/images/f_bico01.png" /></p>
                <span>입점문의</span>
              </a>
            </li>
            <li>
              <a href="javascript:;">
                <p class="img"><img src="@/assets/images/f_bico02.png" /></p>
                <span>공급사 로그인</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  computed: {
    ...mapGetters(['shopInfo'])
  },
  methods: {}
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/layout/components/Footer.vue